import Hexapi from "../../../utility/HexAPI/Hexapi";

// `layoutjson` historically stored a plain array of elements. It now stores
// { elements, margin } so the page margin is remembered per template too —
// this parses both shapes so older saved templates still load fine.
export function parseLayoutJson(json) {
  try {
    const parsed = JSON.parse(json || "[]");
    if (Array.isArray(parsed)) {
      return { elements: parsed, margin: null };
    }
    return {
      elements: Array.isArray(parsed?.elements) ? parsed.elements : [],
      margin: parsed?.margin || null,
    };
  } catch {
    return { elements: [], margin: null };
  }
}

export async function apiGetTemplates(agentId) {
  const obj = {
    query: `[dbo].[CRM_Proc_Quotation_Layout_GetTemplates] @agentid='{0}'`,
    queryArr: [`${agentId}`],
  };
  const res = await Hexapi(obj);
  const rows = res?.["templates"] || [];

  return rows.map((r) => {
    const { elements, margin } = parseLayoutJson(r.layoutjson);
    return {
      layoutId: r.layoutid,
      key: `tpl_${r.layoutid}`,
      label: r.quotationname,
      description: r.orientation || "",
      orientation: r.orientation,
      elements,
      margin,
    };
  });
}

export async function apiGetProducts(agentId) {
  const obj = {
    query: `[dbo].[CRM_Proc_Product_Master_GetList] @agentid='{0}'`,
    queryArr: [`${agentId}`],
  };
  const res = await Hexapi(obj);
  const rows = res?.[""] || [];

  return rows.map((r) => ({
    productId: r.recid ?? r.recid,
    productName: r.product ?? r.product,
  }));
}

export async function apiGetLayoutsByProduct(productId) {
  const obj = {
    query: `CRM_Proc_Quotation_Layout_GetByProduct @ProductId='{0}'`,
    queryArr: [productId],
  };
  const res = await Hexapi(obj);
  const rows = res || [];

  return rows.map((r) => {
    const { elements, margin } = parseLayoutJson(r.layoutjson);
    return {
      layoutId: r.layoutid,
      quotationName: r.quotationname,
      productId: r.productid,
      orientation: r.orientation,
      elements,
      margin,
      modifiedDate: r.modifieddate,
    };
  });
}

export async function apiSaveLayout(payload) {
  const layoutJson = JSON.stringify({ elements: payload.elements, margin: payload.margin }).replace(/'/g, "''");
  const quotationName = (payload.quotationName || "").replace(/'/g, "''");

  const obj = {
    query: `CRM_Proc_Quotation_Layout_Submit
              @LayoutId='{0}', @QuotationName='{1}', @ProductIds='{2}',
               @PageSize='{3}',
              @CustomMmW='{4}', @CustomMmH='{5}', @Orientation='{6}',
              @LayoutJson='{7}'`,
    queryArr: [
      payload.layoutId || -1,
      quotationName,
      Array.isArray(payload.productId) && payload.productId.length ? payload.productId.join(",") : -1,
      "A4",
      -1,
      -1,
      payload.orientation,
      layoutJson,
    ],
  };
  const res = await Hexapi(obj);
  return res?.[0]?.LayoutId;
}

export async function apiDeleteLayout(layoutId) {
  const obj = {
    query: `CRM_Proc_Quotation_Layout_Delete @LayoutId='{0}', @UserId='{1}'`,
    queryArr: [layoutId, null],
  };
  await Hexapi(obj);
  return true;
}